<ng-template #messageTemplate let-comment="comment">
  <div class="width-100">
    <h2>
      <mat-icon *ngIf="canSeePrivate && comment.type===typeMessage.private">lock</mat-icon><mat-icon>person</mat-icon>
      <span class="commentator">{{comment.commentator_obj?.first_name}} {{comment.commentator_obj?.last_name}}</span>
      <span class="date">
        le {{comment.dt_created|date:'dd/MM/yyyy'}} à {{comment.dt_created|date:'HH:mm'}}
        <button *ngIf="canDeleteMessage && isOwner(comment)" mat-icon-button
                (click)="confirmDelete(comment)"
                matTooltip="Supprimer le message"
                color="primary" aria-label="supprimer le message">
          <mat-icon>delete</mat-icon>
        </button>
      </span>
    </h2>
    <div class="text" [ngClass]="{'private': comment.type===typeMessage.private}">
      <span [innerHTML]="comment.content"></span>
    </div>
    <div>
      <div fxFlex fxLayoutAlign="end center" *ngIf="comment.attachments_obj?.length > 0">
          <div class="attachment-link" *ngFor="let attachment of comment.attachments_obj">
            <button mat-flat-button
               [matTooltip]="fileToolTip(attachment)"
               (click)="downloadFile(attachment)">
              <span class="avis-line-content" style="color: #2979ff">{{ attachment.filename }}</span>&nbsp;&nbsp;
              <mat-icon color="accent">attach_file</mat-icon>
            </button>
          </div>
      </div>
    </div>
  </div>
</ng-template>
<mat-progress-bar [mode]="'indeterminate'" *ngIf="commentsLoading"></mat-progress-bar>
<div class="messagerie container" *ngIf="comments?.length > 0">
  <ul class="messages-list" fxFlex fxLayout="column">
    <ng-container *ngFor="let comment of comments">
        <li class="message" *ngIf="comment.type === typeMessage.public">
          <ng-container *ngTemplateOutlet="messageTemplate; context: {'comment': comment}"></ng-container>
        </li>
        <li class="message human-private" *ngIf="comment.type === typeMessage.private && canSeePrivate">
          <ng-container *ngTemplateOutlet="messageTemplate; context: {'comment': comment}"></ng-container>
        </li>
    </ng-container>
  </ul>
</div>
